import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    token: null,
    user: null,
  },
  reducers: {
    saveToken: (state, action) => {
      console.log('saveToken', action)
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.token = action.payload
    },
    saveUser: (state, action) => {
      state.user = action.payload.user
      state.token = action.payload.token
    },
  },
})

// Action creators are generated for each case reducer function
export const { saveToken, saveUser } = userSlice.actions

export default userSlice.reducer
